import { InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Layout } from "../Layout";
import { AppHeader } from "JS/React/Components/AppHeader";
import { useNavigate } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";
import { DocumentFavList } from "./Components/DocumentFavList";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";

const StyledRoot = styled("div")({});

export interface DocumentsProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {}

export const FavoritesDocumentsListing = (props: DocumentsProps) => {
    const { className, ...rest } = props;
    const navigate = useNavigate();
    const { linkProvider } = useRouting();
    const { homeStack } = useGlobalNavStack();

    const onBackClick = () => {
        if (!homeStack?.isHomeTrack) {
            navigate(linkProvider.react.favorites().index());
        } else {
            navigate(linkProvider.react.home());
        }
    };

    return (
        <Layout>
            <StyledRoot {...rest} className={className}>
                <AppHeader
                    title={"Favorites Documents"}
                    canGoBack
                    searchable={false}
                    onBackClick={onBackClick}
                />
                <DocumentFavList />
            </StyledRoot>
        </Layout>
    );
};
